export default __webpack_public_path__ + "static/media/Report.3ee02d67.jpg";